const SET_COLUMN_CATEGORIES = (state, data) => {
  state.columnCategories = data
}

const SET_COLUMN_CATEGORIES_TREE = (state, data) => {
  state.columnCategoriesTree = data
}

const PUSH = (state, data) => {
  state.columnCategories.push(data)
}

const UPDATE = (state, data) => {
  const columnCategory = state.columnCategories.find(x => x.id === data.id)

  columnCategory.name = data.name
}

export default {
  PUSH,
  UPDATE,
  SET_COLUMN_CATEGORIES,
  SET_COLUMN_CATEGORIES_TREE
}
